import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './PaymentComponent.css';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import {Collapse, CardBody, Card, Button, Form} from 'reactstrap';
import {EDU_ORG} from './../../../reducers/organization/organizations';
import {CURRENCIES} from '../../../constants/constants';
import {Utils} from '../../../utils/utils';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import { StorageApi } from '../../../utils/storageApi';
import moment from "moment";

const requiredSelectFields = ['countryCode'];

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        ":hover": {
            backgroundColor: state.isSelected ? '#89aa11' : 'rgba(137, 170, 17, 0.44)'
        },
        backgroundColor: state.isSelected ? '#89aa11' : 'white',
        cursor: 'pointer',
        fontSize: '.9rem',
        paddingTop: '0',
        paddingBottom: '0',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    }),
    control: (provided, state) => ({
        ...provided,
        fontSize: '.875rem',
        cursor: 'pointer',
        minHeight: 'calc(1.5em + .5rem + 2px)',
        height: 'calc(1.5em + .5rem + 2px)',
        border: '1px solid #ced4da',
        ":hover": {
            border: '1px solid #ced4da',
        },
        borderColor: state.isFocused ? '#80bdff' : '#ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0 5px 0 0'
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    menu: styles => ({
        ...styles,
        marginTop: '0',
        marginBottom: '0',
        borderRadius: '0'
    }),
    menuList: styles => ({
        ...styles,
        paddingTop: '0',
        paddingBottom: '0'
    })
};

class PaymentComponent extends Component {
    constructor(props) {
        super(props);

        let bankDataCountryCode = StorageApi.getBankDataCountryCode() || this.props.orgCountryCode;
        this.state = {
            isOpenBankInfo: false,
            continentCode: "",
            countryCode: bankDataCountryCode,
            isEditCountry: false,
            bankDataCountryCode: bankDataCountryCode,
            requiredFieldError: null
        };
    }

    componentDidMount() {
        this.props.setCurrentContinentByCountry(this.state.bankDataCountryCode);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.continentCode !== this.state.continentCode) {
            this.setState({continentCode: nextProps.continentCode});
        }
    }

    render() {
        if (_.isNil(this.props.price)) {
            return null;
        }
        return (
            <div className='payment-container'>
                <h4 className='page-label'>{_.get(this.props.translation, 'payment.title')}</h4>
                {this.props.orgPermissions.hasIVs ?
                    <h6>{_.get(this.props.translation, 'payment.total_money_label').replace("{orgName}", this.props.orgName) + "0"}</h6> : null}
                {this.props.orgPermissions.hasIVs ? <br/> : null}
                <h5 className="text-center">{_.get(this.props.translation, 'finance.prices_label')}</h5>
                {
                    this.state.isEditCountry ?
                        this.renderLocationForm()
                        :
                        <div className="location-info-container">
                            <h6>{_.get(this.props.translation, sharedLabelsPath.country_label) + ": "}{_.get(this.props.translation, sharedLabelsPath.countries)[this.state.bankDataCountryCode]}</h6>
                            <IconContainer
                                className="edit-location-icon"
                                icon='create'
                                onClick={this.handleChangeLocation}
                                title={_.get(this.props.translation, sharedLabelsPath.edit_button)}
                            />
                        </div>
                }
                {this.renderPriceData()}
                <ul className="payment-list-container">
                    <li>
                        {_.get(this.props.translation, 'payment.account_id_label').replace("{iban}", _.get(Utils.getBankDataByCountry(this.state.bankDataCountryCode, this.props.translation), 'iban_number'))}
                        <IconContainer
                            className="payment-info-icon"
                            icon='info'
                            onClick={this.toggle}
                            title={_.get(this.props.translation, 'payment.bank_details_label')}
                        />
                        <Collapse isOpen={this.state.isOpenBankInfo}>
                            <Card>
                                <CardBody>
                                    <h6>{_.get(this.props.translation, 'payment.about_us_label')}</h6>
                                    <i>{_.get(this.props.translation, 'payment.bank_data_label')}</i><br/>
                                    <div className="bank-data-container">
                                        {_.get(Utils.getBankDataByCountry(this.state.bankDataCountryCode, this.props.translation), 'bank_data')}
                                    </div>
                                </CardBody>
                            </Card>
                        </Collapse>
                    </li>
                    <li>
                        {_.get(this.props.translation, 'payment.create_account_label') + ' '}
                        <b>{_.get(this.props.translation, 'payment.create_account_message_label').replace("{orgName}", this.props.orgName)}</b>
                    </li>
                    <li>
                        {_.get(this.props.translation, 'payment.annual_fee_label') + ' '}
                        <b>{_.get(this.props.translation, 'payment.annual_fee_message_label').replace("{orgName}", this.props.orgName)}</b>
                    </li>
                </ul>
                <br/>
                {this.getEduOrgNotes()}
                <br/>
                <h6>{_.get(this.props.translation, 'payment.wire_delay_label')}</h6>
            </div>
        );
    }

    renderLocationForm = () => {
        let continentParams = {
            value: "continentCode",
            title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label),
            onChange: this.handleChangeContinent,
            type: 'select',
            content: Utils.getLocationOptions(
                this.props.continents,
                _.get(this.props.translation, sharedLabelsPath.continents)
            ),
            placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
            isDisabled: !this.props.continents,
            isRequired: true
        };
        let countryParams = {
            value: "countryCode",
            title: _.get(this.props.translation, sharedLabelsPath.country_label),
            onChange: this.handleChangeCountry,
            type: 'select',
            content: Utils.getLocationOptions(
                this.props.countries,
                _.get(this.props.translation, sharedLabelsPath.countries)
            ),
            placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
            isDisabled: !this.props.countries,
            isRequired: true
        };

        return (
            <Form onSubmit={this.handleChangeLocationSubmit} className="location-form">
                <div className="location-form-group">
                    <h6 className="location-label">{_.get(this.props.translation, sharedLabelsPath.country_label) + ":"}</h6>
                    <div className="location-controls-container">
                        <div className="location-select-container">
                            {this.getSelectElement(continentParams)}
                        </div>
                        <div className="location-select-container">
                            {this.getSelectElement(countryParams)}
                        </div>
                        <Button type="submit" color="link">
                            <IconContainer
                                className="save-location-icon"
                                icon='save'
                                title={_.get(this.props.translation, sharedLabelsPath.save_changes_button)}
                            />
                        </Button>
                        <IconContainer
                            className="discard-location-icon"
                            icon='clear'
                            onClick={this.handleDiscardLocationChange}
                            title={_.get(this.props.translation, sharedLabelsPath.cancel_button)}
                        />
                    </div>
                </div>
            </Form>
        )
    };

    getSelectElement = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <Select
                id={id}
                key={params.title}
                selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                options={params.content}
                onSelect={params.onChange}
                placeholder={params.placeholder}
                disabled={params.isDisabled}
                requiredFieldError={this.state.requiredFieldError === params.value}
                customStyles={customStyles}
            />
        );
    };

    handleChangeContinent = (selectedOption) => {
        this.props.onContinentSet(selectedOption.value);
        this.setState({countryCode: ""});
    };

    handleChangeCountry = (selectedOption) => {
        this.setState({countryCode: selectedOption.value});
    };

    renderPriceData = () => {
        if ((this.props.price.annualFee && this.props.price.annualFee.amount !== this.props.price.pricingPreset.annualFee.amount) ||
            (this.props.price.consentRequestFee && this.props.price.consentRequestFee.amount !== this.props.price.pricingPreset.consentRequestFee.amount)) {
            return [
                <h6 key='default-preset'>{_.get(this.props.translation, 'finance.default_preset_label')
                    .replace('{annual_fee_amount}', this.props.price.pricingPreset.annualFee.amount + CURRENCIES[this.props.price.pricingPreset.annualFee.currency])
                    .replace('{consent_request_fee_amount}', this.props.price.pricingPreset.consentRequestFee.amount + CURRENCIES[this.props.price.pricingPreset.consentRequestFee.currency])}</h6>,
                <h6 key='agreed-deviation'>{_.get(this.props.translation, 'finance.agreed_deviation_label')
                    .replace('{annual_fee_amount}', (this.props.price.annualFee ? this.props.price.annualFee.amount : this.props.price.pricingPreset.annualFee.amount) + CURRENCIES[this.props.price.annualFee ? this.props.price.annualFee.currency : this.props.price.pricingPreset.annualFee.currency])
                    .replace('{consent_request_fee_amount}', (this.props.price.consentRequestFee ? this.props.price.consentRequestFee.amount : this.props.price.pricingPreset.consentRequestFee.amount) + CURRENCIES[this.props.price.consentRequestFee ? this.props.price.consentRequestFee.currency : this.props.price.pricingPreset.consentRequestFee.currency])}</h6>,
                <h6 key='period'>
                    {_.get(this.props.translation, 'finance.period_label') + ': '}
                    {_.isNil(this.props.price.validTill) ? _.get(this.props.translation, 'finance.forever_label') :
                        (_.get(this.props.translation, 'finance.till_label') + ' ' + moment(this.props.price.validTill).format('L'))}
                </h6>,
                <h6 key='list-label'>{_.get(this.props.translation, 'payment.list_label')}</h6>
            ];
        }
        return [
            <h6 key='request-cost'>{_.get(this.props.translation, 'finance.request_cost_label') + ": " + this.props.price.pricingPreset.consentRequestFee.amount + CURRENCIES[this.props.price.pricingPreset.consentRequestFee.currency]}</h6>,
            <h6 key='list-label'>{_.get(this.props.translation, 'payment.list_label') + ' ' + this.props.price.pricingPreset.annualFee.amount + CURRENCIES[this.props.price.pricingPreset.annualFee.currency]}</h6>
        ]
    };

    toggle = () => {
        this.setState({
            isOpenBankInfo: !this.state.isOpenBankInfo
        });
    };

    getEduOrgNotes = () => {
        if (this.props.orgType === EDU_ORG) {
            return (
                <div>
                    <h5 className="text-center">{_.get(this.props.translation, 'payment.edu_org_message_label')}</h5>
                    <span>{_.get(this.props.translation, 'payment.edu_org_message_company_checks')}</span>
                    <br/>
                    <br/>
                    <span>{_.get(this.props.translation, 'payment.edu_org_message_list_title')}</span>
                    <ul>
                        <li>{_.get(this.props.translation, 'payment.edu_org_message_list_item_one')}</li>
                        <li>{_.get(this.props.translation, 'payment.edu_org_message_list_item_two')}</li>
                    </ul>
                    <span>{_.get(this.props.translation, 'payment.edu_org_message_joining')}</span>
                    <br/>
                    <br/>
                    <span>{_.get(this.props.translation, 'payment.edu_org_message_note_title')}</span>
                    <br/>
                    <span>{_.get(this.props.translation, 'payment.edu_org_message_note')}</span>
                </div>
            )
        }
    }

    handleChangeLocation  = () => {
        this.setState({
            isEditCountry: true
        });
    }

    handleChangeLocationSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        this.setState({
            isEditCountry: false,
            bankDataCountryCode: this.state.countryCode,
            requiredFieldError: null
        });

        StorageApi.setBankDataCountryCode(this.state.countryCode);
    }

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }

    handleDiscardLocationChange = () => {
        if ( this.state.countryCode !== this.state.bankDataCountryCode) {
            this.props.setCurrentContinentByCountry(this.state.bankDataCountryCode);
        }
        this.setState({
            isEditCountry: false,
            countryCode: this.state.bankDataCountryCode,
            requiredFieldError: null
        });
    }
}

PaymentComponent.propTypes = {
    orgName: PropTypes.string,
    orgType: PropTypes.string,
    price: PropTypes.object,
    translation: PropTypes.object.isRequired,
    orgPermissions: PropTypes.object,
    orgCountryCode: PropTypes.string,
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    onContinentSet: PropTypes.func.isRequired,
    setCurrentContinentByCountry: PropTypes.func.isRequired
};

export default PaymentComponent;



// WEBPACK FOOTER //
// ./src/components/commonComponents/paymentComponent/PaymentComponent.js